<template>
  <li class="max-w-[1280px] w-full mx-auto">
    <MenuLink
      :menu="menu"
      :formattedMenuState="[formattedMenu, setFormattedMenu]"
      level="first"
      :setActiveMobileMenu="setActiveMobileMenu"
    ></MenuLink>
    <Transition @enter="enter" @leave="leave">
      <ul
        v-if="menu.subMenu?.length && menu.activeDropdown"
        :class="[
          {'mx-4': isRoot},
          {'mx-2 pb-1': !isRoot},
          'bg-black/10 rounded-lg my-1 dark:bg-white/5',
          !menu.activeDropdown && 'hidden',
          menu.activeDropdown && 'block',
        ]"
      >
        <MobileMenuComponent
          v-for="(menu, index) in menu.subMenu"
          :key="index"
          :menu="menu"
          :isRoot="false"
          :setActiveMobileMenu="setActiveMobileMenu"
        ></MobileMenuComponent>
      </ul>
    </Transition>
  </li>
</template>

<script setup lang="ts">
import { defineProps, ref } from "vue";
import Menu from "./Menu.vue";
import { enter, leave } from "@/components/MainMenu/main-menu";
import MenuLink from "./MenuLink.vue";
import { FormattedMenu, nestedMenu } from "../SideMenu/side-menu";

const props = defineProps({
  menu: Object,
  isRoot: Boolean,
  position: String,
  menuIndex: Number,
  setActiveMobileMenu: Function,
});
const formattedMenu = ref([]);
const setFormattedMenu = (
  computedFormattedMenu: Array<FormattedMenu | "divider">
) => {
  formattedMenu.value = computedFormattedMenu;
};
</script>
